import React from "react";
import { DateInput } from "@/components/DateInput";
import { Plus, Trash2, CalendarRange } from "lucide-react";
import { eur } from "./format";

export function BudgetPeriodsEditor({ value, onChange, projectStart, projectEnd }) {
  const periods = value || [];
  const total = periods.reduce((s, p) => s + (parseFloat(p.budget_amount) || 0), 0);

  function add() {
    const last = periods[periods.length - 1];
    onChange([...periods, {
      start_date: last ? (last.end_date || "") : (projectStart || ""),
      end_date: last ? "" : (projectEnd || ""),
      budget_amount: "", label: "",
    }]);
  }
  const update = (i, patch) => onChange(periods.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  const remove = (i) => onChange(periods.filter((_, j) => j !== i));
  const inp = "w-full px-2.5 py-2 border border-neutral-200 focus:border-brand focus:outline-none text-sm bg-white";

  return (
    <div data-testid="budget-periods-editor">
      <div className="flex items-center justify-between mb-2">
        <label className="font-mono text-[10px] uppercase tracking-widest text-ink-muted flex items-center gap-1.5">
          <CalendarRange className="h-3.5 w-3.5" /> Perioade de buget (€)
        </label>
        <button type="button" data-testid="budget-period-add" onClick={add}
          className="flex items-center gap-1 text-[12px] text-brand hover:underline"><Plus className="h-3.5 w-3.5" /> Adaugă perioadă</button>
      </div>
      {periods.length === 0 && (
        <div className="text-[12px] text-ink-muted border border-dashed border-neutral-200 p-3">
          Nicio perioadă definită — se folosește bugetul total distribuit pe durata proiectului. Adaugă perioade ca să urmărești bugetul pe faze (ex. 01/01–01/04: 25.000 €, 01/04–01/08: 40.000 €).
        </div>
      )}
      <div className="space-y-2">
        {periods.map((p, i) => (
          <div key={i} className="grid grid-cols-[1fr_1fr_1fr_1.2fr_auto] gap-2 items-center" data-testid={`budget-period-row-${i}`}>
            <DateInput value={p.start_date || ""} data-testid={`budget-period-start-${i}`}
              onChange={(e) => update(i, { start_date: e.target.value })} className={inp} />
            <DateInput value={p.end_date || ""} data-testid={`budget-period-end-${i}`}
              onChange={(e) => update(i, { end_date: e.target.value })} className={inp} />
            <input type="number" step="any" min="0" placeholder="Buget €" value={p.budget_amount ?? ""} data-testid={`budget-period-amount-${i}`}
              onChange={(e) => update(i, { budget_amount: e.target.value })} className={`${inp} font-mono`} />
            <input placeholder="Etichetă (ex. Faza 1)" value={p.label || ""} data-testid={`budget-period-label-${i}`}
              onChange={(e) => update(i, { label: e.target.value })} className={inp} />
            <button type="button" data-testid={`budget-period-remove-${i}`} onClick={() => remove(i)}
              className="text-ink-muted hover:text-red-600 p-1"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      {periods.length > 0 && (
        <div className="mt-2 flex items-center justify-between text-[12px]">
          <span className="text-ink-muted">Perioadele se pot înlănțui pe aceeași dată (ex. 01/01–01/04 și 01/04–01/08): ziua comună aparține perioadei următoare.</span>
          <span className="font-semibold" data-testid="budget-periods-total">Total buget: {eur(total)}</span>
        </div>
      )}
    </div>
  );
}
